module.exports = __webpack_public_path__ + "assets/img/img267.302ab1c8.png";